import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Hero = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 pt-16 sm:px-6 overflow-hidden">
      <div className="container mx-auto max-w-6xl">
        <div className="min-w-0 text-center space-y-8 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm animate-scale-in">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm text-primary font-medium">
              {t('hero.badge')}
            </span>
          </div>

          <h1 className="break-words text-4xl font-bold sm:text-5xl md:text-8xl">
            <span className="text-gradient">{t('hero.title')}</span>
            <br />
            <span className="text-foreground">{t('hero.subtitle')}</span>
          </h1>

          <p className="text-xl md:text-2xl text-foreground/80 max-w-3xl mx-auto leading-relaxed font-medium">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button
              size="lg"
              className="group bg-primary hover:bg-primary/90 text-primary-foreground shadow-glow transition-all duration-300 hover:scale-105"
            >
              {t('hero.getStarted')}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-foreground hover:text-primary border-primary/30 hover:bg-primary/10 hover:border-primary/50 transition-all duration-300"
            >
              {t('hero.watchDemo')}
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-3 pt-16 sm:gap-8 max-w-2xl mx-auto">
            <div className="text-center space-y-2 animate-slide-up" style={{ animationDelay: "0.2s" }}>
              <div className="text-2xl font-bold text-primary sm:text-4xl">34</div>
              <div className="text-sm text-foreground/70 font-medium">{t('hero.uniqueStrengths')}</div>
            </div>
            <div className="text-center space-y-2 animate-slide-up" style={{ animationDelay: "0.3s" }}>
              <div className="break-words text-2xl font-bold text-secondary sm:text-4xl">{t('hero.aiPoweredLabel')}</div>
              <div className="text-sm text-foreground/70 font-medium">{t('hero.aiPowered')}</div>
            </div>
            <div className="text-center space-y-2 animate-slide-up" style={{ animationDelay: "0.4s" }}>
              <div className="text-4xl font-bold text-accent">∞</div>
              <div className="text-sm text-foreground/70 font-medium">{t('hero.growthPotential')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
